import { Buffer } from 'buffer';

// Make Buffer available globally for crypto operations that expect Node.js global
if (typeof window !== 'undefined') {
   
  window.Buffer = Buffer;
  // Set global for libraries that expect it (like WalletConnect)
  window.global = window;
  // Ensure GLOBAL is also defined for older libraries
  window.GLOBAL = window;
  
  // Ensure Buffer.isBuffer is properly defined
  if (typeof Buffer.isBuffer !== 'function') {
    Buffer.isBuffer = function isBuffer(obj) {
      return obj != null && obj._isBuffer === true;
    };
  }
  
  console.log('[Buffer Polyfill] Initialized global Buffer');
}

// Provide a minimal `process` shim for browser context. Vite/rollup will treeshake
// unused properties, but many libraries still feature‐test `process.env` or
// `process.browser`.  We expose only what is strictly required.
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  // We intentionally avoid copying all env vars – build-time replacement via
  // import.meta.env should be used instead.  The object only needs to exist.
  /** @type {any} */
  const shim = { env: {}, browser: true }; // `browser` flag is a common convention
   
  window.process = shim;
}

export {}; 